import { render, staticRenderFns } from "./LearningSubject.vue?vue&type=template&id=2a1f4e2e&scoped=true&"
import script from "./LearningSubject.vue?vue&type=script&lang=js&"
export * from "./LearningSubject.vue?vue&type=script&lang=js&"
import style0 from "./LearningSubject.vue?vue&type=style&index=0&id=2a1f4e2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1f4e2e",
  null
  
)

/* custom blocks */
import block0 from "./LearningSubject.vue?vue&type=custom&index=0&blockType=link&href=https%3A%2F%2Ffonts.googleapis.com%2Fcss2%3Ffamily%3DMontserrat%3Awght%40100%26family%3DRubik%3Aital%2Cwght%400%2C300%3B0%2C400%3B1%2C300%3B1%2C400%26display%3Dswap&rel=stylesheet"
if (typeof block0 === 'function') block0(component)

export default component.exports